module.exports = __webpack_public_path__ + "img/logo.91235838.png";